document.addEventListener('DOMContentLoaded', () => {
  const checkBoxes = document.querySelectorAll(
    '.webform-submission-form-leadfolders-node-3397-form .webform-entity-checkboxes--wrapper input[type="checkbox"],.webform-submission-form-leadfolders-node-3479-form .webform-entity-checkboxes--wrapper input[type="checkbox"]',
  );

  const updateCheckboxState = (checkbox) => {
    const folderItem = checkbox.closest('.formItem');
    const actionElement = folderItem.querySelector('.form__action');
    const iconElement = actionElement.querySelector('i');
    const statusElement = folderItem.querySelector('.form__status');

    if (checkbox.checked) {
      actionElement.textContent = 'Verwijderen';
      iconElement.className = 'fa-duotone fa-trash-can-xmark';
      actionElement.classList.add('form__action--delete');
      statusElement.style.display = 'block';
      setTimeout(() => {
        statusElement.style.opacity = '1';
        statusElement.style.transform = 'scale(1)';
      }, 50); // Delay and grow effect
    } else {
      actionElement.textContent = 'Toevoegen';
      iconElement.className = 'fa-solid fa-circle-plus';
      actionElement.classList.remove('form__action--delete');
      statusElement.style.opacity = '0';
      statusElement.style.transform = 'scale(0.5)';
      setTimeout(() => {
        statusElement.style.display = 'none';
      }, 10); // Delay to hide
    }

    // Re-insert icon element
    actionElement.prepend(iconElement);
  };

  checkBoxes.forEach((checkbox) => {
    updateCheckboxState(checkbox);

    checkbox.addEventListener('change', () => {
      updateCheckboxState(checkbox);
    });
  });
});
